module.exports = {
  "dateRange": function dateRange(args) {
    return "Nuo ".concat(args.startDate, " iki ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "Pasirinkta ".concat(args.date);
  },
  "finishRangeSelectionPrompt": "Spustel\u0117kite, kad baigtum\u0117te pasirinkti dat\u0173 interval\u0105",
  "maximumDate": "Paskutin\u0117 galima data",
  "minimumDate": "Pirmoji galima data",
  "next": "Paskesnis",
  "previous": "Ankstesnis",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Pasirinkta data: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Pasirinktas intervalas: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "Spustel\u0117kite, kad prad\u0117tum\u0117te pasirinkti dat\u0173 interval\u0105",
  "todayDate": function todayDate(args) {
    return "\u0160iandien, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "\u0160iandien, pasirinkta ".concat(args.date);
  }
};